<script setup lang='ts'>
import { APP_ROUTER } from '@qctsw/common'
import { timeFrom } from '@qctsw/utils'
import { logicComplaintOperation, logicUserComplaintList } from '~/logic/user/complaint'
import { getComplaintStatus, getDisposeTypeCode, getScoreText } from '@/shared/function'
import { LOAD_STATE } from '~/shared/types'

const showModal = ref(false)
const { complainApplySurveyBottom } = logicComplaintOperation()
const {
  data,
  state,
  getData,
} = logicUserComplaintList('up')

function scrollHandler(e: any) {
  if (e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight - 10 && [LOAD_STATE.LOAD_MORE].includes(state.value))
    getData()
}

useActivatedWatch(() => [
  watch(showModal, () => {
    if (showModal.value && !data.value.length)
      getData(1)
  }),
])
</script>

<template>
  <button v-bind="$attrs" @click="showModal = true">
    <slot />
  </button>
  <n-modal v-model:show="showModal">
    <n-card
      size="medium" :bordered="false"
      title="申请为一追到底" role="dialog" aria-modal="true"
      class="w-140 rounded-md"
      closable :on-close="() => showModal = false"
    >
      <div class="h-100 overflow-auto scrollbar-default pb-2" @scroll="scrollHandler">
        <UtilLoadState :state="state" :reload-handler="() => getData()">
          <template v-if="data.length">
            <div
              v-for="v, i in data" :key="i"
              class="flex items-center justify-between border-1 border-slate-2 rounded-md mb-sm p-sm"
            >
              <div flex-grow>
                <p class="line-clamp-2 mb-sm">
                  {{ v.title }}
                </p>
                <p class="text-3.25 flex items-center justify-between">
                  <span :class="[`status-${v.complainStatusCode}`]">{{ getComplaintStatus(v.complainStatusCode) }}</span>
                  <span>{{ timeFrom(v.createTime) }}</span>
                </p>
              </div>
              <button class="btn-primary flex-shrink-0 ml-sm" @click="complainApplySurveyBottom(v.complainId)">
                申请
              </button>
            </div>
          </template>
          <BasicEmpty v-else />
        </UtilLoadState>
      </div>
      <NuxtLink target="_blank" class="btn-primary py-2 m-auto block w-50 text-center" :to="APP_ROUTER.publish()">
        发布新投诉
      </NuxtLink>
    </n-card>
  </n-modal>
</template>

<style lang='scss' scoped>
@import url('@/assets/styles/status.scss');
</style>
